import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

const useStyles = makeStyles(({spacing}) => ({
  daysBeforeTip: {
    fontSize: "12px",
    color: grey[500],
    lineHeight: "20px",
    letterSpacing: "0.4px",
  },
  title: {
    fontWeight: 500,
    lineHeight: "150%",
  },
  form: {
    padding: spacing(3, 3, 2, 3),
    backgroundColor: grey[50],
    borderRadius: "8px",
    border: "1px solid #E0E0E0",
  },
  currencyTitle: {
    fontSize: "10px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.40)",
    background: "rgba(0, 0, 0, 0.15)",
    borderRadius: "4px",
    padding: spacing(0.5, 0.75),
  },
}));

export default useStyles;
